import { ModelSchema } from "api/client/types/DjangoClient.types";
import { ColorsByTaskStatus } from "./ColorsByTaskStatus";
import { RunStatus, TaskStatus } from "./constants";

type ColorsByRunStatus = {
  [status in ModelSchema["RunSchema"]["status"]]: string;
};

export const colorsByRunStatus: ColorsByRunStatus = {
  [RunStatus["NEW"]]: "lightgrey",
  [RunStatus["RUNNING"]]: ColorsByTaskStatus[TaskStatus["RUNNING"]],
  [RunStatus["COMPLETE"]]: ColorsByTaskStatus[TaskStatus["COMPLETE"]],
  [RunStatus["FAILED"]]: ColorsByTaskStatus[TaskStatus["FAILED"]],
} as const;
